export default __webpack_public_path__ + "static/media/broken-cup.b146b9c6.svg";